import {gql} from '@apollo/client';

export const GET_HUB_LIST = gql`
    query GetHubList {
        hubList: getHubList {
            id
            name
            sortingCode
            siteType
            addressLine1
            zipcode
            pickupDeadlineTime
            appointmentDeadlineTime
            timezone
        }
    }
`;

export interface HubType {
    id: string;
    name: string;
    sortingCode?: string;
    siteType: number;
    addressLine1?: string;
    zipcode?: string;
    pickupDeadlineTime?: string;
    appointmentDeadlineTime?: string;
    timezone?: string;
}

export interface GetHubListResponse {
    hubList: HubType[];
} 